import React from "react";
import styles from "./assign.module.scss";

interface ToggleProps {
  checked: boolean;
  index: number;
  onChange: (index: number) => void;
  customStyle?: string;
  disabled?: boolean;
  type: string;
}

export const Toggle: React.FC<ToggleProps> = ({ checked, index, onChange, customStyle = "", disabled, type }) => {
  return (
    <div className={`${styles.switchContainer} ${customStyle}`}>
      <label className={styles.switchLabel}>Mandatory</label>
      <div className={styles.switchWrapper}>
        <input
          type="checkbox"
          id={`mandatorySwitch-${type}-${index}`}
          className={styles.switchInput}
          checked={checked}
          onChange={() => onChange(index)}
          disabled={disabled}
        />
        <label htmlFor={`mandatorySwitch-${type}-${index}`} className={`${styles.switchSlider} ${checked ? styles.checked : ""}`} />
      </div>
    </div>
  );
};
